<template>
  <div class="r-note-modal">
    <Modal footer-hide v-model="show" width="652">
      <div class="password-box">
        <div class="change-password">{{ $t("customer.addNotes") }}</div>
        <div class="individual-account">
          {{ $t("customer.customerManagement") }}
        </div>
        <div class="header-box">

          <img v-if="fileMsg" :src="fileMsg.urlPath" alt="" />
          <img v-if="imgPath" :src="imgPath" alt="" />
          <img v-else src="../assets/images/defaultHeader.png" alt="" />
          <!-- <div class="header-mask"></div> -->
        </div>
        <div class="change-img common-hover">
          <input
            type="file"
            name="filead"
            v-show="false"
            @change="changeHeader"
            id="filead"
            ref="pathClear"
            class="inputfile"
            multiple="multiple"
            accept="image/*"
          />

          <label for="filead" class="common-hover">
            <span
              style="margin-right: 8px; font-size: 12px"
              class="iconfont icontijiao"
            ></span>
            <span>{{ $t("customer.uploadImg") }}</span>
          </label>
        </div>
        <div class="common-flex common-flex-end">
          <div class="back common-hover" @click="backHead">
            {{ $t("password.back") }}
          </div>
          <div class="submit common-hover" @click="save">{{ $t("password.submit") }}</div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: "r-change-header-modal",
  data() {
    return {
      show: false,
      fileMsg:''
    };
  },
  methods: {
    ...mapActions([
      'uploadAttachmentAction',//附件上传
      'saveAttachmentAction',//保存
      'deleteAttachmentAction',//删除附件
    ]),
    backHead(){
      this.show = false
      this.$emit('handleHeaderShow')
    },
    // 保存
    save(){
      console.log('保存')
      this.saveAttachmentAction({
        id:this.fileMsg.id,
        hostId:this.customerId,
        hostName:'customer',
        type:1
      }).then(res=>{
        if(res.code==0){
           if(this.attachId){
             this.deleteAttachmentAction({ids:[this.attachId]}).then(res=>{

             })
           }
          this.$emit("saveHeader", false);
          this.$emit('handleHeaderShow')

        }
      })
    },
     closeCardJournal() {
      var file = document.getElementById("filead");
      file.value = ""; //file的value值只能设置为空字符串
      // this.fileList = [];
    },
    // 修改头像
    changeHeader(e) {
      // deleteAttachmentAction
      let file = document.getElementById("filead").files
      let params = new FormData(); // 声明一个FormData对象
      params.append("file", file[0]);
      this.uploadAttachmentAction(params).then(res=>{
        if(res.code==0){
          this.fileMsg = res.data
          this.closeCardJournal()
        }
      })
    },
  },
  watch: {
    headerShow: {
      handler(newval, oldval) {
        this.show = newval;
      },
      immediate: true,
    },
    show: {
      handler(newval, oldval) {
        if (newval == false) {
          this.$emit("handleHeaderShow", newval);
        }
      },
      immediate: true,
    },
  },
  props: {
    headerShow: Boolean,
    customerId:[Number,String],
    imgPath:String,
    attachId:[Number,String]
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-input {
  border: none;
}
.change-img {
  width: 118px;
  height: 32px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  font-size: 14px;
  font-family: Roboto, Roboto-Regular;
  font-weight: 400;
  text-align: center;
  color: #525e73;
  line-height: 32px;
  margin: 20px auto 40px;
}
.header-box {
  width: 160px;
  height: 160px;
  margin: 0 auto;
  > img {
    width: 160px;
    height: 160px;
    display: block;
  }
  // .header-mask{
  //   width: 160px;
  //   height: 160px;
  //   position: ;
  // }
}
.password-box {
  height: 418px;
  width: 620px;
  padding: 14px 24px;
  .back,
  .submit {
    width: 116px;
    height: 40px;
    background: #b5bac4;
    line-height: 40px;
    font-size: 14px;
    font-family: Roboto, Roboto-Bold;
    font-weight: 700;
    text-align: left;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }
  .current-balance {
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #999999;
    line-height: 16px;
  }
  .current-price {
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #0a4dcc;
    line-height: 16px;
  }
  .submit {
    background: #0a4dcc;
    margin-left: 14px;
  }
  .change-password {
    font-size: 30px;
    font-weight: 700;
    text-align: left;
    font-family: Times, Times-Bold;
    color: #000000;
    line-height: 37px;
    margin-bottom: 3px;
  }
  .individual-account {
    font-size: 12px;
    font-family: Times, Times-Roman;
    font-weight: Roman;
    text-align: left;
    color: #666666;
    line-height: 14px;
    margin-bottom: 50px;
  }
  .input-box {
    height: 32px;
    width: 372px;
    border-bottom: 1px solid rgba(8, 25, 56, 0.1);
    margin-bottom: 45px;
    padding-bottom: 12px;
    div {
      width: 120px;
      font-size: 14px;
      font-family: Roboto, Roboto-Regular;
      font-weight: 400;
      text-align: left;
      color: #333333;
      line-height: 16px;
    }
    input {
      height: 20px;
      line-height: 20px;
      margin-left: 70px;
      border: none;
      outline: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-change-header-modal.vue